import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { StorefrontOutlined, LocationOnOutlined, ChevronRight } from "@mui/icons-material";

const ModalSucursal = ({ open, onClose, sucursales, onSelect }) => {
  const empty = !sucursales || sucursales.length === 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.2)",
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <Box sx={{ px: 3, pt: 2.5, pb: 1.5, borderBottom: "1px solid", borderColor: "divider" }}>
        <Typography variant="caption" fontWeight={600} color="text.secondary"
          sx={{ textTransform: "uppercase", letterSpacing: "0.08em", display: "block", mb: 0.25 }}>
          Punto de retiro
        </Typography>
        <DialogTitle sx={{ p: 0, fontSize: "18px", fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
          <StorefrontOutlined color="primary" fontSize="small" />
          Elegir sucursal
        </DialogTitle>
      </Box>

      <DialogContent sx={{ px: 2.5, py: 2, maxHeight: 360 }}>
        {empty ? (
          <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
            <StorefrontOutlined sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
            <Typography variant="body2" color="text.secondary">
              No hay sucursales disponibles en este momento.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {sucursales.map((suc, index) => (
              <Box
                key={suc.id}
                onClick={() => onSelect(suc)}
                sx={{
                  border: "1.5px solid",
                  borderColor: "divider",
                  borderRadius: "12px",
                  padding: "14px 16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  transition: "all 0.15s ease",
                  "&:hover": {
                    borderColor: "primary.main",
                    bgcolor: "primary.50",
                    "& .arrow-icon": { opacity: 1, transform: "translateX(0)" },
                  },
                }}
              >
                {/* Número / ícono */}
                <Box sx={{
                  width: 36, height: 36, borderRadius: "10px",
                  bgcolor: "primary.50", color: "primary.main",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 700, fontSize: "14px", flexShrink: 0,
                }}>
                  {index + 1}
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body2" fontWeight={600} noWrap>
                    {suc.nombre}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }}>
                    <LocationOnOutlined sx={{ fontSize: 13, color: "text.disabled", flexShrink: 0 }} />
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {suc.direccion || "Dirección no informada"}
                    </Typography>
                  </Box>
                </Box>

                <ChevronRight
                  className="arrow-icon"
                  fontSize="small"
                  sx={{
                    color: "primary.main",
                    opacity: 0,
                    transform: "translateX(-4px)",
                    transition: "all 0.15s ease",
                    flexShrink: 0,
                  }}
                />
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid", borderColor: "divider" }}>
        {!empty && (
          <Chip
            label={`${sucursales.length} sucursal${sucursales.length !== 1 ? "es" : ""}`}
            size="small"
            variant="outlined"
            sx={{ mr: "auto", fontSize: "12px" }}
          />
        )}
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: "8px", textTransform: "none" }}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSucursal;